import { combineReducers, createStore } from "redux";
// 管理端
import course from "../Admin/store/reducer/index";
// 移动端
import mobile from "../Mobile/store/reducer/index";

const reducer = combineReducers({
  course,
  mobile
});

const store = createStore(reducer);

export default store;